<template>
  <div class="flex-1 px-6 py-6 overflow-y-auto">
    <div class="pb-4 border-b border-gray-300">
      <h1 class="text-2xl font-semibold text-gray-900">
        จัดการการใช้งานลูกค้า
      </h1>
      <p>ตั้งค่าจัดการการใช้งานให้กับลูกค้า</p>
    </div>

    <!-- Error Message -->
    <div
      v-if="errors.length > 0"
      class="px-4 py-3 rounded-md bg-red-600 bg-opacity-20 flex items-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-600"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
      <p class="text-base font-semibold text-red-800 flex-1 px-3">
        {{ errors[0] }}
      </p>
      <button @click="errors = []" type="button" class="focus:outline-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-red-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
    <!-- End Error Message -->

    <ValidationObserver v-slot="{ invalid }">
      <div class="divide-y divide-gray-300">
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >เวลาเก็บรักษาข้อมูล (เดือน)<span class="text-xl text-red-600"
              >*
            </span>
          </label>
          <div class="col-span-2 max-w-lg">
            <ValidationProvider
              name="เวลาเก็บรักษาข้อมูล"
              rules="required|integer"
              v-slot="{ errors }"
            >
              <input
                v-model.trim="customer.data_retention_period"
                type="text"
                class="
                  leading-none
                  focus:ring-cyan-500 focus:border-cyan-500
                  block
                  w-full
                  shadow-sm
                  border-gray-300
                  rounded-md
                "
              />
              <span class="text-base text-red-600">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >รหัสอ้างอิงพนักงาน</label
          >
          <div class="">
            <AppToggleInput v-model="customer.is_employee_reference_code" />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >Microsoft Entra ID</label
          >
          <div class="">
            <AppToggleInput v-model="customer.is_ms_entraid" />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >Mobile Time Recorder</label
          >
          <div class="">
            <AppToggleInput v-model="customer.is_mobile_time_recorder" />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >Mobile Payroll</label
          >
          <div class="">
            <AppToggleInput v-model="customer.is_mobile_payroll" />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >Mobile Leave</label
          >
          <div class="">
            <AppToggleInput v-model="customer.is_mobile_leave" />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >Mobile announcement</label
          >
          <div class="">
            <AppToggleInput v-model="customer.is_mobile_announcement" />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >วันเริ่มต้นใช้งาน</label
          >
          <div class="col-span-2 max-w-lg">
            <DateInput
              clearable
              v-model="customer.activate_start_date"
              :resetValidate="resetValidateStartDate"
              @resetValidateCompleted="resetValidateStartDate = false"
              @invalid="(value) => (startDateValid = value)"
            />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >วันสิ้นสุดการใช้งาน</label
          >
          <div class="col-span-2 max-w-lg">
            <DateInput
              clearable
              v-model="customer.activate_end_date"
              :resetValidate="resetValidateEndDate"
              @resetValidateCompleted="resetValidateEndDate = false"
              @invalid="(value) => (endDateValid = value)"
            />
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700">โซนเวลา</label>
          <div class="col-span-2 max-w-lg">
            <AppAutoComplete
              v-model="selectedTimezone"
              :isSearch="true"
              :options="timezone"
              label="โซนเวลา"
              item-text-key="text"
              item-value-key="timeZoneId"
            />
            <span v-if="validateTimezone" class="text-base text-red-600"
              >จำเป็นต้องระบุ โซนเวลา</span
            >
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >ใส่โน็ตเพิ่มเติม</label
          >
          <textarea
            v-model="customer.note"
            rows="3"
            class="
              col-span-2
              max-w-lg
              shadow-sm
              focus:ring-cyan-500 focus:border-cyan-500
              block
              w-full
              border border-gray-300
              rounded-md
            "
          ></textarea>
        </div>
        <!-- <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >จำนวนพนักงานสูงสุด</label
          >
          <div class="col-span-2 max-w-lg">
            <ValidationProvider
              name="จำนวนพนักงานสูงสุด"
              rules="integer"
              v-slot="{ errors }"
            >
              <input
                v-model.trim="customer.max_employee"
                type="text"
                class="
                  leading-none
                  focus:ring-cyan-500 focus:border-cyan-500
                  block
                  w-full
                  shadow-sm
                  border-gray-300
                  rounded-md
                "
              />
              <span v-if="errors.length === 0" class="text-base text-gray-400"
                >ไม่ระบุ หมายถึงไม่จำกัด</span
              >
              <span class="text-base text-red-600">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div> -->

        <div class="py-4 grid grid-cols-4">
          <div class="col-start-2 col-span-2">
            <button
              @click="onSave"
              :disabled="loading || invalid || validateTimezone"
              :class="{
                'cursor-not-allowed': loading || invalid || validateTimezone,
              }"
              type="button"
              class="
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-transparent
                shadow-sm
                px-4
                py-2
                bg-cyan-600
                text-base
                font-medium
                text-white
                hover:bg-cyan-700
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
                sm:w-auto
              "
            >
              <svg
                v-if="loading"
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              บันทึกการเปลี่ยนแปลง
            </button>
            <button
              @click="onCancel"
              :disabled="loading"
              :class="{ 'cursor-not-allowed': loading }"
              type="button"
              class="
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-gray-300
                shadow-sm
                px-4
                py-2
                bg-white
                text-base
                font-medium
                text-gray-700
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
                sm:ml-3 sm:w-auto
              "
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <!-- confirm leave page -->
    <AppConfirmLeavePageModal
      :show="isConfirmLeavePageShow"
      :next="isConfirmLeavePageNextFunction"
      @cancel="onCancelConfirmLeavePage"
      @submit="onSubmitConfirmLeavePage"
    />
    <!-- end confirm leave page -->
  </div>
</template>

<script>
import timezone from '@/data/timezone.json'
import moment from 'moment'

import { extend } from 'vee-validate'
import { integer, required } from 'vee-validate/dist/rules'

import AppAutoComplete from '@/components/AppAutoComplete'
import AppConfirmLeavePageModal from '@/components/AppConfirmLeavePageModal'
import AppToggleInput from '@/components/AppToggleInput'
import DateInput from '@/components/DateInput'

// No message specified.
// extend('required', required)

// Override the default message.
extend('required', {
  ...required,
  message: 'จำเป็นต้องระบุ {_field_}',
})
extend('integer', {
  ...integer,
  message: '{_field_} ต้องเป็นตัวเลขจำนวนเต็ม',
})

export default {
  name: 'CustomerUse',

  components: {
    AppToggleInput,
    AppAutoComplete,
    DateInput,
    AppConfirmLeavePageModal,
  },

  data() {
    return {
      loading: false,
      currentCustomer: {
        is_employee_reference_code: false,
      },
      customer: {
        is_employee_reference_code: false,
      },
      timezone,
      selectedTimezone: null,
      errors: [],
      timeout: null,
      isConfirmLeavePageShow: false,
      isConfirmLeavePageNextFunction: null,
      startDateValid: false,
      endDateValid: false,
      resetValidateStartDate: false,
      resetValidateEndDate: false,
    }
  },

  computed: {
    isDataChange() {
      if (
        this.currentCustomer.is_ms_entraid !== this.customer.is_ms_entraid ||
        this.currentCustomer.is_mobile_time_recorder !==
          this.customer.is_mobile_time_recorder ||
        this.currentCustomer.is_mobile_payroll !==
          this.customer.is_mobile_payroll ||
        this.currentCustomer.is_mobile_leave !==
          this.customer.is_mobile_leave ||
        this.currentCustomer.is_mobile_announcement !==
          this.customer.is_mobile_announcement ||
        this.currentCustomer.is_employee_reference_code !==
          this.customer.is_employee_reference_code ||
        this.currentCustomer.data_retention_period !==
          this.customer.data_retention_period ||
        this.currentCustomer.activate_start_date !==
          this.customer.activate_start_date ||
        this.currentCustomer.activate_end_date !==
          this.customer.activate_end_date ||
        this.currentCustomer.max_employee != this.customer.max_employee ||
        this.currentCustomer.note !== this.customer.note
      ) {
        return true
      }
      return false
    },

    validateTimezone() {
      if (
        (this.customer.activate_start_date ||
          this.customer.activate_end_date) &&
        !this.selectedTimezone
      ) {
        return true
      }
      return false
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', true)

    const uuid = this.$route.params.uuid
    this.fetchCustomer(uuid)
  },

  methods: {
    onCancelConfirmLeavePage() {
      this.isConfirmLeavePageShow = false

      this.errors = []
    },

    onSubmitConfirmLeavePage(obj) {
      this.isConfirmLeavePageShow = false
      this.timeout = setTimeout(() => {
        obj.next()
      }, 200)
      return
    },

    async fetchCustomer(uuid) {
      try {
        this.loading = true

        const customer = await this.$store.dispatch(
          'customer/fetchCustomer',
          uuid
        )

        this.$store.commit('setBreadcrumbs', [
          { text: 'รายชื่อลูกค้า', routeName: 'CustomerList' },
          {
            text: customer.title_th || 'ลูกค้า',
            routeName: 'CustomerDetails',
          },
          { text: 'จัดการการใช้งานลูกค้า', routeName: 'CustomerUse' },
        ])

        this.currentCustomer = {
          data_retention_period: customer.data_retention_period,
          is_employee_reference_code: customer.is_employee_reference_code,
          is_ms_entraid: customer.is_ms_entraid,
          is_mobile_time_recorder: customer.is_mobile_time_recorder,
          is_mobile_payroll: customer.is_mobile_payroll,
          is_mobile_leave: customer.is_mobile_leave,
          is_mobile_announcement: customer.is_mobile_announcement,
          activate_start_date: customer.activate_start_date
            ? moment.utc(customer.activate_start_date).format('DD/MM/YYYY')
            : '',
          activate_end_date: customer.activate_end_date
            ? moment.utc(customer.activate_end_date).format('DD/MM/YYYY')
            : '',
          activate_timezone: customer.activate_timezone || '',
          company_uuid: customer.company_uuid,
          max_employee: customer.max_employee || '',
          note: customer.note || '',
        }
        this.customer = {
          data_retention_period: customer.data_retention_period,
          is_employee_reference_code: customer.is_employee_reference_code,
          is_ms_entraid: customer.is_ms_entraid,
          is_mobile_time_recorder: customer.is_mobile_time_recorder,
          is_mobile_payroll: customer.is_mobile_payroll,
          is_mobile_leave: customer.is_mobile_leave,
          is_mobile_announcement: customer.is_mobile_announcement,
          activate_start_date: customer.activate_start_date
            ? moment.utc(customer.activate_start_date).format('DD/MM/YYYY')
            : '',
          activate_end_date: customer.activate_end_date
            ? moment.utc(customer.activate_end_date).format('DD/MM/YYYY')
            : '',
          activate_timezone: customer.activate_timezone || '',
          company_uuid: customer.company_uuid,
          max_employee: customer.max_employee || '',
          note: customer.note || '',
        }

        this.selectedTimezone =
          this.timezone.find(
            (element) => element.adjustment === customer.activate_timezone
          ) || null
      } catch (error) {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching customer',
        }
        this.$store.dispatch('notification/add', notification)
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    onCancel() {
      const uuid = this.$route.params.uuid
      this.fetchCustomer(uuid)

      this.errors = []
      this.resetValidateStartDate = true
      this.resetValidateEndDate = true
    },

    async onSave() {
      if (this.validateTimezone || this.startDateValid || this.endDateValid) {
        return true
      }

      this.errors = []

      try {
        const customerUpdate = {
          company_uuid: this.customer.company_uuid,
          data_retention_period:
            Number(this.customer.data_retention_period) || 0,
          is_employee_reference_code: this.customer.is_employee_reference_code,
          is_ms_entraid: this.customer.is_ms_entraid,
          is_mobile_time_recorder: this.customer.is_mobile_time_recorder,
          is_mobile_payroll: this.customer.is_mobile_payroll,
          is_mobile_leave: this.customer.is_mobile_leave,
          is_mobile_announcement: this.customer.is_mobile_announcement,
          activate_start_date: this.customer.activate_start_date
            ? moment
                .utc(this.customer.activate_start_date, 'DD/MM/YYYY')
                .format('YYYY-MM-DD')
            : null,
          activate_end_date: this.customer.activate_end_date
            ? moment
                .utc(this.customer.activate_end_date, 'DD/MM/YYYY')
                .format('YYYY-MM-DD')
            : null,
          activate_timezone: this.selectedTimezone
            ? this.selectedTimezone.adjustment
            : null,
          max_employee: Number(this.customer.max_employee) || null,
          note: this.customer.note || null,
        }

        this.loading = true

        await this.$store.dispatch(
          'customer/editCustomerConfigActivate',
          customerUpdate
        )

        const notification = {
          type: 'success',
          message: 'Your customer has been updated!',
        }
        this.$store.dispatch('notification/add', notification)

        this.currentCustomer = {
          company_uuid: customerUpdate.company_uuid,
          data_retention_period: customerUpdate.data_retention_period,
          is_employee_reference_code: customerUpdate.is_employee_reference_code,
          is_ms_entraid: customerUpdate.is_ms_entraid,
          is_mobile_time_recorder: customerUpdate.is_mobile_time_recorder,
          is_mobile_payroll: customerUpdate.is_mobile_payroll,
          is_mobile_leave: customerUpdate.is_mobile_leave,
          is_mobile_announcement: customerUpdate.is_mobile_announcement,
          activate_start_date: customerUpdate.activate_start_date
            ? moment
                .utc(customerUpdate.activate_start_date)
                .format('DD/MM/YYYY')
            : '',
          activate_end_date: customerUpdate.activate_end_date
            ? moment.utc(customerUpdate.activate_end_date).format('DD/MM/YYYY')
            : '',
          activate_timezone: this.selectedTimezone
            ? this.selectedTimezone.adjustment
            : '',
          max_employee: Number(customerUpdate.max_employee) || '',
          note: customerUpdate.note || '',
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors.push(
            error.response.data.message || 'Something went wrong.'
          )
        }

        console.log(error.response)
      } finally {
        this.loading = false
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDataChange) {
      this.isConfirmLeavePageShow = true
      this.isConfirmLeavePageNextFunction = next
      return
    }

    next()
  },
}
</script>
